<template>
  <!-- <div class="bg_gradient"> -->
  <div class="bgImage">
    <nav class="navbar navbar-light bg-transparent">
      <a class="navbar-brand" href="\">
        <!-- <img src="img/brand/CollabHubNav.png"> -->
      </a>
      <form class="navbar-search navbar-search-light form-inline mr-3 d-none d-md-flex ml-lg-auto">
          <div class="form-group mb-0">
              <base-input placeholder="LOGIN:"
                          class="input-group-alternative"
                          alternative=""
                          addon-right-icon=""
                          disabled>
              </base-input>
          </div>
      </form>
    </nav>
    <!-- <div class="spacetop"></div> -->
    <!-- <LandingPage></LandingPage> -->
    <LandingPageNew></LandingPageNew>
  </div>

</template>

<script>
// import LandingPage from '../views/LandingPage.vue';
import LandingPageNew from '../views/LandingPageNew.vue';
export default {
  name: 'LandingPageLayout',
  components: {
    // LandingPage
    LandingPageNew
  }
}
</script>

<style>
/* c55a11
  029bd4
*/
.bg-transparent {
  background-color: transparent !important;
}
.spacetop{
    width: 100%;
    height: 90px;
    /* background: red; */
}



</style>
